import { IWeddingEvent } from '@bridebook/models/source/models/Weddings/Events.types';
import { sortEvents } from '@bridebook/web/lib/events/sort-unified-events';
import { isMainEvent } from '@bridebook/web/lib/events/types';
import partition from 'lodash/partition';

/**
 * Sorts events collecton items by date and time in ascending order keeping the Main Event at the top
 * We can have only one Main Event (Wedding) which doesn't have a date in events collection, so here we just put it at the top
 * If it's required to sort it by date, it has to be pulled from the Wedding data (there are helpers for that in lib/events)
 * @param events Array of events to sort
 * @returns New array of sorted events
 */
export const sortEventsByDate = (events: IWeddingEvent[]): IWeddingEvent[] => {
  if (!Array.isArray(events) || events.length === 0) return [];
  const [mainEvents, notMainEvents] = partition(events, isMainEvent);
  const notMainEventsSorted = sortEvents(notMainEvents);

  return [...mainEvents, ...notMainEventsSorted];
};
